import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const asignadorFuncionImporterSelectors = importerSelectors(
  'asignadorFuncion.importer',
);

export default asignadorFuncionImporterSelectors;
